import { createStyles as d } from "@mantine/core";
var s = d((r, { sticky: a, stickyOffset: o }) => ({
  toolbarGroup: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    margin: `calc(${r.spacing.md}px / 2)`
  },
  toolbar: {
    position: a ? "sticky" : "relative",
    zIndex: 1,
    top: a ? o : 0,
    backgroundColor: r.colorScheme === "dark" ? r.colors.dark[7] : r.white,
    borderBottom: `1px solid ${r.colorScheme === "dark" ? r.colors.dark[7] : r.colors.gray[4]}`,
    borderTopRightRadius: r.radius.sm,
    borderTopLeftRadius: r.radius.sm,
    padding: `${r.spacing.sm}px ${r.spacing.md}px`
  },
  toolbarInner: {
    display: "flex",
    flexWrap: "wrap",
    margin: `calc(${-r.spacing.md}px / 2)`
  },
  toolbarControl: {
    "& + &": {
      borderLeftWidth: 0
    },
    "&:first-of-type": {
      borderTopLeftRadius: r.fn.radius(r.defaultRadius),
      borderBottomLeftRadius: r.fn.radius(r.defaultRadius)
    },
    "&:last-of-type": {
      borderTopRightRadius: r.fn.radius(r.defaultRadius),
      borderBottomRightRadius: r.fn.radius(r.defaultRadius)
    }
  }
}));
export {
  s as default
};
